class Store
{
    constructor()
    {
        this._initBindedVars()
    }

    setRoutes(routes)
    {
        const routesNums = { }
        for (let i = 0; i < routes.length; i++)
        {
            const route = routes[i]
            routesNums[route.name] = i
            for (let j = 0; route.children && j < route.children.length; j++)
            {
                const child = route.children[j]
                routesNums[child.name] = i + j / 10
            }
        }

        this.global.routesNums = routesNums
    }

    _initBindedVars()
    {
        this.global = {
            routesNums: { },
            currentNum: 0,
            isMenuOpen: false,
            blogEnabled: true,
            blogURL: '//blog.zealagency.co'
            // global data
        }
    }

    setRoute(route)
    {
        this.global.currentNum = Number(this.global.routesNums[route.name])
    }
}

const store = new Store()

export default store
